var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "video-modal-overlay",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.handleClose($event)
            }
          }
        },
        [
          _c("div", { staticClass: "video-modal-box" }, [
            _c("div", { staticClass: "video-modal-hd" }, [
              _c("h3", [_vm._v("\n        🎬 商品プロモーション動画\n      ")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "video-modal-close",
                  on: { click: _vm.handleClose }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "video-modal-player" }, [
              _vm.modalData.videoId
                ? _c("div", { staticClass: "video-embed-wrap" }, [
                    _vm.iframeVisible
                      ? _c("iframe", {
                          attrs: {
                            src: _vm.embedUrl,
                            title: "YouTube video player",
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                            allowfullscreen: ""
                          }
                        })
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "video-no-content" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "32",
                          height: "32",
                          viewBox: "0 0 10 10",
                          opacity: "0.4"
                        }
                      },
                      [
                        _c("polygon", {
                          attrs: { points: "2,1 9,5 2,9", fill: "#fff" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("動画が登録されていません")])
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "video-modal-ft" }, [
              _c(
                "button",
                {
                  staticClass: "video-btn-cancel",
                  on: { click: _vm.handleClose }
                },
                [_vm._v("閉じる")]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5719eb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5719eb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/VideoPlayerModal.vue
// module id = null
// module chunks = 